// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vIhP","colBig":"styles_colBig__W195h","colSmall":"styles_colSmall__1l49c"};